export const crudTableDefaultItemActionsLength = 3;
